import { GENDER } from '@vindr/services/constants/common.constant';
import { DefinedColumns } from '@vindr/services/interfaces';
import { useTranslation } from 'react-i18next';

const genderColumn = <T,>(props?: Partial<DefinedColumns<T>>): DefinedColumns<T> => {
  const { t } = useTranslation('Vindoc');

  const {
    title = 'Gender',
    dataIndex = 'sex' as keyof T,
    key = 'sex' as keyof T,
    width = 50,
    ellipsis = true,
    ...rest
  } = props || {};

  return {
    title: t(title),
    dataIndex,
    width,
    key,
    ellipsis,
    render: (text) => t(GENDER[text]),
    ...rest,
  };
};

export default genderColumn;
